import React, {ReactElement, ReactNode} from 'react';
import {Tooltip as Tippy, TooltipProps as TippyProps} from 'react-tippy';

import 'react-tippy/dist/tippy.css';

export interface TippyOptions extends TippyProps {
  tag?: string;
  touchHold?: boolean;
}

interface TooltipProps {
  title: string;
  children?: ReactNode;
  className?: string;
  options?: TippyOptions;
}

function Tooltip({title, children, className = '', options = {}}: TooltipProps): ReactElement {
  return (
    <Tippy
      size="big"
      animation="scale"
      arrow
      inertia
      interactive
      touchHold
      tabIndex={0}
      tag="span"
      title={title}
      // spread options here to ensure defaults are overwritten correctly
      // we want to use the root className so do not overwrite that
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...options}
      className={className}
    >
      {children}
    </Tippy>
  );
}

export default Tooltip;
